import axios from '../plugins/axios'

export default {
    copy(params){
      return axios.post('/api/v1/area_pop_ups/copy', params)
    }
}
